import axios  from "../../services/axios";
import { useMutation } from '@tanstack/react-query';
  
export const fetchTodaysLoad = async () => {
  try {
  const response = await axios.get(`vanorder/load-details`);

  return response.data;
  } catch (error) {
    // Optional: transform error before throwing
    throw new Error(
      error.response?.data?.message || error.message || 'Failed to fetch today\'s load'
    );
  }
};
  
export const fetchVanOrders = async ({ filters, page, perPage }) => {
  try {
    const response = await axios.get('/vanorder/getTodaysOrders', {
      params: {
        ...filters, // include filters like datetime, vanid, customername
        page,
        perPage,
      },
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch today’s van orders. Please try again later.';
  
    throw new Error(message); // Triggers onError in useQuery
  }
  };

  export const createOrder = async (orderData) => {
  try {
    const response = await axios.post('/vanorder/create', orderData);
  
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to create the order. Please try again.';
    throw new Error(message);
  }
  };

export const updateOrder = async (orderData)=>{
  try {
    const response = await axios.put('/vanorder/update-payment', orderData);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to update the order. Please try again.';
    throw new Error(message);
  }
}

  export const fetchOrderDetails = async (orderid) => {
  try {
    const response = await axios.get(`/vanorder/view/${orderid}`);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch order details. Please try again.';
    throw new Error(message);
  }
  };
  export const generateQrCode = async (orderid) => {
  try {
    const response = await axios.get(`/vanorder/generate-qr/${orderid}`, {
      responseType: 'blob', 
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to generate QR code. Please try again.';
    throw new Error(message);
  }
  };
export const validateCouponCode = async (coupon_code, order_price) => {
  try {
    const response = await axios.post(`/vanorder/apply-coupon`, {
      coupon_code,
      order_price,
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.error || // 👈 use backend "error"
      error?.response?.data?.message || 
      error?.message ||
      'Failed to validate coupon details. Please try again.';

    throw new Error(message);
  }
};
 
